import { render } from "./left_menu.vue?vue&type=template&id=838a568e"
import script from "./left_menu.vue?vue&type=script&lang=js"
export * from "./left_menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__